import { jsx as _jsx } from "react/jsx-runtime";
export function TSpacer() { return /*#__PURE__*/ _jsx("div", { style: { height: 8, flexShrink: 0 } }); }
